import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import UserEditForm from "../../components/Forms/UserEditForm";
import api from "../../services/api";
import { HttpStatusCode } from "../../enums/HttpStatusCode";

const UserEditPage = () => {
  const { cpf } = useParams();
  const [formData, setFormData] = useState({
    nome: "",
    email: "",
    cpf: "",
    perfil: "",
    municipio: "",
    regional: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [validationErrors, setValidationErrors] = useState({});

  const handleApiError = (error) => {
    if (error.response?.status === HttpStatusCode.UNPROCESSABLE_ENTITY && Array.isArray(error.response.data.detail)) {
      const fieldErrors = {};
      error.response.data.detail.forEach((err) => {
        const fieldName = err.loc?.[1]; // loc: ['body', 'campo']
        let message = err.msg;
        if (typeof message === 'string' && message.startsWith('Value error, ')) {
          message = message.replace('Value error, ', '');
        }
        if (fieldName) fieldErrors[fieldName] = message;
      });
      setValidationErrors(fieldErrors);
    } else {
      const msg = error.response?.data?.detail || "Erro ao enviar o formulário.";
      setErrorMessage(msg);
    }
  };

  // Buscar dados do usuário ao carregar a página
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await api.get(`/users/${cpf}/edit`);
        const data = response.data;

        // Normaliza os dados para o formato esperado pelo form
        setFormData({
          nome: data.nome || "",
          email: data.email || "",
          cpf: data.cpf || "",
          perfil: data.perfil?.id || (Array.isArray(data.perfil) ? data.perfil[0]?.id : data.perfil) || "",
          municipio: data.municipio?.cod_ibge || data.municipio || "",
          regional: data.regional?.cod_urs || "",
        });
      } catch (error) {
        console.error("Erro ao buscar dados do usuário:", error);
        alert("Erro ao carregar os dados do usuário.");
        setErrorMessage("Erro ao carregar os dados do usuário.");
      }
    };

    fetchUserData();
  }, [cpf]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev)=> ({
      ...prev,
      [name]: value }));
  };

  const handleSubmit = async (e) => {

    e.preventDefault();
    setIsSubmitting(true);
    setSuccessMessage("");
    setErrorMessage("");
    setValidationErrors({});
 
    const sanitizedData = {
      ...formData,
      cpf: formData.cpf ? formData.cpf.replace(/[.-]/g, "") : formData.cpf,
    };

    try {
      await api.put(`/users/${cpf}/edit`, sanitizedData);
      alert("Usuário atualizado com sucesso!");
      const sucessMessage = "Usuário atualizado com sucesso!";
      setSuccessMessage(`${sucessMessage}`);
      setValidationErrors({});
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <UserEditForm
        formData={formData}
        onChange={handleChange}
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        successMessage={successMessage}
        errorMessage={errorMessage}
        validationErrors={validationErrors}
      />
    </div>
  );
};

export default UserEditPage;
